MOVE.HOMEPAGE = (function (MOVE) {
  var init = function () {
  };

  MOVE.HOMEPAGE =
  {
    init: init
  };

  return MOVE.HOMEPAGE;
})(MOVE || {});



// WEBPACK FOOTER //
// ./homepage/homepage.js